import axios from '../../axios/index.js'
import store from '../../../store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default {
  init () {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  checkToken () {
    const token = localStorage.accessToken
    return axios.get('/api/users/me', {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  resetPassword (payload) {
    return axios.post('/api/auth/recover', payload)
  },
  changePassword (payload) {
    const restToken = payload.token
    delete payload.token
    return axios.post(`/api/auth/reset/${restToken}`, payload)
  },
  getPassToken (passtoken) {
    return axios.get(`/api/auth/reset/${passtoken}`)
  },
  loginUser (payload) {
    console.log('login payload', payload)
    return axios.post('/api/auth/login', payload)
  },
  registerUser (payload) {
    console.log('login payload', payload)
    return axios.post('/api/auth/register', payload)
  },
  registerUserCart (payload) {
    console.log('login payload', payload)
    return axios.post('/api/auth/register/cart', payload)
  },
  checkMail (payload) {
    return axios.post('/api/auth/checkmail', payload)
  },
  verifyPhone (payload) {
    return axios.post('/api/auth/verifyPhone', payload)
  },
  getPost (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/posts/${payload.id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getUser (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/users/${payload.id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deletePost (payload) {
    const token = localStorage.accessToken
    return axios.delete(`/api/posts/${payload.id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  changeStatus (payload) {
    const token = localStorage.accessToken
    return axios.put(`/api/posts/${payload.id}/${payload.status}`, {}, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteUser (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/users/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteInteraction (payload) {
    const token = localStorage.accessToken
    return axios.delete(`/api/posts/interaction/${payload.id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getPostSlug (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/posts/${payload.slug}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getPostSlugUser (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/posts/data/${payload.slug}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  savePost (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/posts', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  patchPost (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.patch(`/api/posts/${payload.id}`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  patchUser (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.patch(`/api/users/${payload.id}`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  getUserList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/users', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },

  getFeed (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/posts/feed', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getUsers (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/users/', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getInteractions (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/posts/interaction/list', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getInteractionsAll () {
    const token = localStorage.accessToken

    return axios.get('/api/posts/interaction/list/all', {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  setInteraction (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/posts/interaction', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  getInteraction (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/posts/interaction/code/${payload.code}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  checkFingerPrint (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/posts/interaction/check/${payload.code}/${payload.fingerprint}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getGame (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/posts/interaction/scratch/code/${payload.code}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  setPlayed (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.post(`/api/posts/interaction/${payload.code}/played`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  updateInteraction (payload) {
    const token = localStorage.accessToken
    return axios.put(`/api/posts/interaction/code/${payload.code}`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  sendReminder (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.post(`/api/posts/interaction/reminder/${payload.code}`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  sendReminderAll (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.get('/api/posts/interaction/send_reminder', {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  registerCode (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.post(`/api/posts/interaction/register/${payload.code}`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getRewardsList (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.get(`/api/posts/interaction/rewards/${payload.type}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  uploadImage (payload, onUploadProgress) {
    const token = localStorage.accessToken
    const formData = new FormData()

    formData.append('picture', payload.file)

    console.log(formData)
    return axios.post('/api/posts/uploadfile', formData, {
      headers:{
        'Content-Type': 'multipart/form-data',
        'Authorization': `${token}`
      },
      onUploadProgress
    })
  },

  getService (id) {
    const token = localStorage.accessToken
    return axios.get(`/api/services/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getServiceList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/services/list', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },
  saveService (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/services', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  updateService (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.put(`/api/services/${payload._id}`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteService (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/services/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  getBundleSlug (id) {
    const token = localStorage.accessToken
    return axios.get(`/api/bundle/get/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getBundle (id) {
    const token = localStorage.accessToken
    return axios.get(`/api/bundle/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getBundleList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/bundle/list', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },
  saveBundle (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/bundle', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  saveUser (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/auth/register', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  updateBundle (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.put(`/api/bundle/${payload._id}`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteBundle (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/bundle/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  getSale (id) {
    const token = localStorage.accessToken
    return axios.get(`/api/sale/details/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getSaleList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/sale/list', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getSubscriptions (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/sale/subscriptions', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getInvoice (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/sale/invoice-preview', {
      params: payload,
      headers:{
        Authorization: `${token}`
      }
    })
  },
  saveSale (payload) {
    return axios.post('/api/sale/makePayment', payload)
  },
  saveSaleMakePayment (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/sale/create-subscription', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  newSaleMakePayment (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/sale/new-subscription', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  updateSale (payload) {
    const token = localStorage.accessToken
    console.log('payload patch', payload)
    return axios.put(`/api/sale/details/${payload.id}`, payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteSale (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/sale/details/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },

  getPaymentIntent (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/sale/paymentIntent', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  subscriptionPayment (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/sale/subscription-payment', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getCardInfo (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/users/cards/cardInfo', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  getUserCards () {
    const token = localStorage.accessToken
    return axios.get('/api/users/cards/getCards', {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  saveCard (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/users/cards/saveCard', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  saveCardForUser (payload) {
    return axios.post(`/api/users/cards/saveCard/${payload.user_id}`, payload)
  },
  makeDefault (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/users/cards/makeDefault', payload, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  deleteCard (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/users/cards/deleteCard/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  },
  cancelSubscription (id) {
    const token = localStorage.accessToken
    return axios.delete(`/api/sale/cancel-subscription/${id}`, {
      headers:{
        Authorization: `${token}`
      }
    })
  }
}
